const openTab = (tabId) => {
    const tab = document.querySelector(`#${tabId}`);
    if (tab && !tab.classList.contains("active")) {
        tab.click();
    }
};

export const onboardingCallbacks = {
    // Battery dashboard
    "open-battery-dashboard-hero-tab": () => {
        openTab("tab-hero");
    },
    "open-battery-dashboard-power-charts-tab": () => {
        openTab("tab-power-charts");
    },
    "open-battery-dashboard-battery-charts-tab": () => {
        openTab("tab-battery-charts");
    },
    "open-battery-dashboard-location-charts-tab": () => {
        openTab("tab-location-charts");
    },
    "open-battery-dashboard-fast-charger-charts-tab": () => {
        openTab("tab-fast-charger-charts");
    },
    "open-battery-dashboard-double-fast-charger-charts-tab": () => {
        openTab("tab-double-fast-charger-charts");
    },
    "open-battery-dashboard-safety-tab": () => {
        openTab("tab-safety");
    },
    "open-battery-dashboard-alerts-tab": () => {
        openTab("tab-alerts");
    },
    "open-battery-dashboard-logs-tab": () => {
        openTab("tab-logs");
    },
    // Customers show
    "open-customers-batteries-tab": () => {
        openTab("tab-batteries");
    },
    "open-customers-team-tab": () => {
        openTab("tab-team");
    },
};
